/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { Constants, USER_ROLES } from '@pwc/pwc-deals-web-common';

import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

import userTokenService from '../../../common/services/security/userTokenService';
import GroupPermissionsType from '../models/GroupPermissionsType';

const useGroupsPermissions = (projectId: number): GroupPermissionsType => {
  const userRole = useSelector(getUserRole);
  const isPwcUser = userRole === USER_ROLES.PWC_USER;
  const [permissions, setPermissions] = useState<GroupPermissionsType>({
    hasPermission: false,
    isClientUser: false,
    isPwcReadOnlyRole: false,
  });
  const checkPermissions = async () => {
    const isPwcReadOnlyRole = Boolean(
      await userTokenService.hasProjectRoles(projectId, [
        Constants.USER_ROLES.PWC_READONLY_DISPLAY,
        Constants.USER_ROLES.PWC_READONLY,
      ])
    );
    const hasPermission = isPwcUser && !isPwcReadOnlyRole;
    const isClientUser = !isPwcUser;

    setPermissions({
      hasPermission,
      isClientUser,
      isPwcReadOnlyRole,
    });
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    checkPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, userRole]);

  return permissions;
};

export default useGroupsPermissions;
